import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import printParcelDebitNote from '../../../../utils/printers/DebitNote';

const PrintCargoDebitNoteButton = ({ parcel }) => {
  const handlePrintDebitNote = () => {
    printParcelDebitNote(parcel);
  };

  return (
    <Button color="light" className="border" onClick={handlePrintDebitNote}>
      <i className="fa fa-print" />
      {' Imprimir Nota de Débito'}
    </Button>
  );
};

PrintCargoDebitNoteButton.propTypes = {
  parcel: PropTypes.instanceOf(Object).isRequired,
};

export default PrintCargoDebitNoteButton;
